export const second = (n: number) => n * 1000;
export const minute = (n: number) => 60 * second(n);
export const hour = (n: number) => 60 * minute(n);

export function msToTime(ms: number) {
  const seconds = Math.floor(ms / 1000);
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  // Добавляем нули впереди, если число меньше 10
  const h = hours.toString().padStart(2, "0");
  const m = minutes.toString().padStart(2, "0");
  const s = secs.toString().padStart(2, "0");
  return `${h}:${m}:${s}`;
}

export function sToTime(sec: number) {
  const seconds = Math.floor(sec);
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  // Добавляем нули впереди, если число меньше 10
  const h = hours.toString().padStart(2, "0");
  const m = minutes.toString().padStart(2, "0");
  const s = secs.toString().padStart(2, "0");
  return `${h}:${m}:${s}`;
}
